export default "__VITE_ASSET__XGBZDc6N__"